import React from "react"
import { graphql } from "gatsby"
import FullWidthPromoModules from "../../promos/gridLayout2/FullWidthPromoModules"
import OneLargeTwoSmall from "../../promos/gridLayout1/OneLargeTwoSmall"

export interface IGridLayout1 {
  promos: {
    fieldGroupName: string
  }
}

export interface IGridLayout2 {
  promos: any
}

interface IPromosProps {
  reverseOrder: boolean
  promos: IGridLayout1 | IGridLayout2
  header: string
  subHeader: string
}

const Promos: React.FC<IPromosProps> = ({
  reverseOrder,
  promos,
  header,
  subHeader,
}) => {
  if (!promos || !promos[0]) return null

  const promoType =
    promos[0].fieldGroupName && promos[0].fieldGroupName.split("_").slice(-1)[0]

  return (
    <>
      {promoType === "GridLayout1" && (
        <div className="mb-[30px]">
          {header && (
            <h2 className="mx-auto mt-[50px] max-w-lg text-center text-darkBlue">
              {header}
            </h2>
          )}
          {subHeader && (
            <p className="mx-auto mt-1 text-center text-subTitle2 font-semibold text-mediumGrey">
              {subHeader}
            </p>
          )}
          <OneLargeTwoSmall {...promos[0]} reverseOrder={reverseOrder} />
        </div>
      )}

      {promoType === "GridLayout2" && (
        <div className="mb-[15px]">
          <FullWidthPromoModules {...promos[0]} />
        </div>
      )}
    </>
  )
}

export default Promos

export const fragment = graphql`
  fragment Promos on WpDefaultTemplate_Acf_Modules {
    ... on WpDefaultTemplate_Acf_Modules_Promos {
      fieldGroupName
      reverseOrder
      promos {
        ... on WpDefaultTemplate_Acf_Modules_Promos_Promos_GridLayout1 {
          fieldGroupName
        }
        ... on WpDefaultTemplate_Acf_Modules_Promos_Promos_GridLayout2 {
          fieldGroupName
        }
      }
      header
      subHeader
    }
  }
`
